import { gql } from '@apollo/client';

import { PageInfoFragmentDoc } from '../../../graphql/fragments/PageInfo.generated';
import type * as GraphQLTypes from '../../../graphql/types.generated';
export type ProductAttributesQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
  first?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  last?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  order?: GraphQLTypes.InputMaybe<
    Array<GraphQLTypes.CoreProductAttributeOrderInput> | GraphQLTypes.CoreProductAttributeOrderInput
  >;
}>;

export type ProductAttributesQueryResult = { __typename?: 'Query' } & {
  coreProductAttributes?: GraphQLTypes.Maybe<
    { __typename?: 'CoreProductAttributeConnection' } & Pick<GraphQLTypes.CoreProductAttributeConnection, 'totalCount'> & {
        nodes?: GraphQLTypes.Maybe<
          Array<
            { __typename?: 'CoreProductAttribute' } & Pick<GraphQLTypes.CoreProductAttribute, 'id' | 'name' | 'type'> & {
                permissions: { __typename?: 'CoreProductAttributePermissions' } & {
                  canDelete: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
                  canUpdate: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
                };
              }
          >
        >;
        pageInfo: { __typename: 'PageInfo' } & Pick<
          GraphQLTypes.PageInfo,
          'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'
        >;
      }
  >;
};

export const ProductAttributesDocument = gql`
  query productAttributes(
    $accountId: String!
    $first: Int
    $last: Int
    $after: String
    $before: String
    $order: [CoreProductAttributeOrderInput!]
  ) {
    coreProductAttributes(accountId: $accountId, first: $first, last: $last, after: $after, before: $before, order: $order) {
      nodes {
        id
        name
        permissions {
          canDelete {
            value
          }
          canUpdate {
            value
          }
        }
        type
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
  }
  ${PageInfoFragmentDoc}
`;
